<ng-container *transloco="let t">
  <form *ngIf="options" (submit)="onSubmit()" novalidate>

    <div class="p-mb-2 p-text-right">
      <div *ngIf="inEdit !== true">
        <button withRight="admin.planning-orders.edit" (click)="onEdit()" type="button" pButton [label]="t('common.labels.edit')" class="p-button-sm p-mb-2" [disabled]="(submitting === true || busy === true) ? true : null"></button>
        <ng-container *ngIf="!order?.isCancelled()">
          <ng-container *ngIf="order?.status === 'requested' && submitting !== true" widthRight="admin.planning-orders.order">
            <button *ngIf="order?.isOrderable() === true" (click)="onTakeOrder()" type="button" pButton [label]="t('common.labels.order2')" icon="pi pi-shopping-cart" class="p-button-success p-button-sm p-ml-2 p-mb-2" [disabled]="(busy === true) ? true : null"></button>
            <button *ngIf="order?.isOrderable() !== true" type="button" pButton [label]="t('common.labels.order2')" icon="pi pi-shopping-cart" class="p-button-secondary p-button-outlined p-button-sm p-ml-2 p-mb-2" disabled></button>
          </ng-container>
          <button *ngIf="submitting === true" widthRight="admin.planning-orders.order" type="button" pButton [label]="t('common.labels.order2')" icon="pi pi-spin pi-spinner" class="p-button-success p-button-sm p-ml-2 p-mb-2" disabled></button>
        </ng-container>
        <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}" [disabled]="(submitting === true || busy === true) ? true : null"></button>
        <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div role="alert" class="p-messages p-component" *ngIf="order?.status === 'requested' &&  clearingInfo !== null">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper" style="align-items: start;">
          <span class="p-message-icon pi pi-exclamation-triangle" style="margin-top: 2px;"></span>
          <span class="p-message-summary" style="margin-top: 2px;">Info</span>
          <span class="p-message-detail" [innerHTML]="clearingInfo"></span>
        </div>
      </div>
    </div>

    <app-order-detail-jobinformation
      [form]="form"
      [options]="options"
      [order]="order"
      [texts]="texts"
      [mode]="mode"
      [inEdit]="inEdit"
      [submitting]="submitting"
      (changed)="businessunitChanged($event)"
      #jobinformation
    >
    </app-order-detail-jobinformation>

    <app-order-detail-orderdata
      [form]="form"
      [options]="options"
      [order]="order"
      [templates]="templates"
      [texts]="texts"
      [mode]="mode"
      [inEdit]="inEdit"
      [submitting]="submitting"
      [businessunit]="selectedBusinessunit"
      (changed)="templateChanged($event)"
      #orderdata
    >
    </app-order-detail-orderdata>

    <app-order-detail-candidates
      [form]="form"
      [options]="options"
      [order]="order"
      [texts]="texts"
      [mode]="mode"
      [inEdit]="inEdit"
      [submitting]="submitting"
      [template]="selectedTemplate"
      (sendInvitation)="sendInvitation($event)"
      #candidates
    >
    </app-order-detail-candidates>

    <app-order-detail-participants
      [form]="form"
      [options]="options"
      [order]="order"
      [texts]="texts"
      [mode]="mode"
      [inEdit]="inEdit"
      [submitting]="submitting"
      (sendInvitation)="sendInvitation($event)"
      #participants
    >
    </app-order-detail-participants>

    <app-order-detail-documents
      [form]="form"
      [options]="options"
      [order]="order"
      [texts]="texts"
      [mode]="mode"
      [inEdit]="inEdit"
      [submitting]="submitting"
      #documents
    >
    </app-order-detail-documents>

    <div class="p-text-right p-mt-4" *ngIf="inEdit === true">
      <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
    </div>

  </form>

  <p-dialog [header]="t('common.really_rescind')" [(visible)]="cancelVisible" [style]="{width: '380px'}" [draggable]="false" [modal]="true" [closable]="false">
    <form (submit)="sendCancellation()">
      <div class="p-mb-4">
        <p [innerHtml]="t('common.messages.really_rescind', { value: order?.name })"></p>
        <p *ngIf="order?.status !== 'requested'">
          <app-form-control [cid]="'reason'" [control]="cancelForm.get('reason')" [type]="'select'" [options]="optionsReasons" [label]="t('common.labels.cancellation_reason')"></app-form-control>
        </p>
      </div>
      <p-footer>
        <div class="p-text-right">
          <button pButton (click)="cancelCancellation()" type="button" label="{{ t('common.labels.no') }}" class="p-button-outlined p-button-secondary p-mr-2" [disabled]="(busy === true) ? true : null"></button>
          <button *ngIf="busy !== true" pButton type="submit" label="{{ t('common.labels.yes') }}" class="p-button-success"></button>
          <button *ngIf="busy === true" pButton type="submit" label="{{ t('common.labels.yes') }}" icon="pi pi-spinner pi-spin" class="p-button-success" disabled></button>
        </div>
      </p-footer>
    </form>
  </p-dialog>

  <p-dialog [header]="t('common.labels.change_date_location') + ': ' + order?.name + ' (' + order?.ordernumber + ')'" [(visible)]="moveVisible" [style]="{width: '80vw'}" [draggable]="false" [modal]="true">
    <app-move-order
      *ngIf="moveVisible === true"
      [order]="order"
      [options]="options"
      (closed)="moveVisible = false"
      (submitted)="onReplaceOrder($event)"
    ></app-move-order>
  </p-dialog>

  <p-dialog [header]="t('common.labels.finish')" [(visible)]="finishVisible" [style]="{width: '80vw'}" [draggable]="false" [modal]="true">
    <app-order-detail-finish-dialog
      *ngIf="finishVisible === true"
      [order]="order"
      [options]="options"
      (closed)="finishVisible = false"
      (submitted)="onFinishOrder($event)"
    ></app-order-detail-finish-dialog>
  </p-dialog>

</ng-container>
